"use strict";

window.FoG = window.FoG || {};

window.FoG.Newsletter = (function($) {
  var COOKIE_POPUPSHOWN = 'newsletterCta--shown';
  var COOKIE_SIGNEDUP = 'newsletter--signedup';
  
  function handleNewsletterSubmit(e) {
    e.preventDefault();

    var $form = $(this);
    var $emailInput = $form.find('input[type=email]');
    var emailAddr = $emailInput.val();

    var fnSuccess = () => {
      FoG.Modal.message($('<span></span>').html('<b>Thanks for signing up for the newsletter!</b><br>Welcome to Future of Good.'));
      $emailInput.val('');
    };
    
    NA.Ajax.postForm($form, 'newsletterSignup', fnSuccess, FoG.Modal.errorFromAjaxResponse);
    Cookies.set(COOKIE_SIGNEDUP, 1, { expires: 3000 });
  }
  
  function initPopupCta() {
    var $postFooter = $('.articleFooter__author');
    
    /* DISABLED May 2019: Popup now shows on all pages
    // CTA only shown on articles
    if (!$postFooter.length) { return; }*/
    
    /* DISABLED OCT 2019: Disable popups entirely */
    return;
      
    var $newsletterModal = $('#newsletter-modal');
    var $modalContent = $newsletterModal.children('.newsletter-modal-content');

    var popupShown = (1 == Cookies.get(COOKIE_POPUPSHOWN));
    var userSignedUp = (1 == Cookies.get(COOKIE_SIGNEDUP));

    var enablePopup = (!popupShown && !userSignedUp) || (window.location.hash.substring(1) == 'show-cta-popup');
    if (!enablePopup) { return; }

    var fnShowPopup = function() {
      NA.Modal.triggerModal($newsletterModal);
      $newsletterModal.addClass('fade-in');
      Cookies.set(COOKIE_POPUPSHOWN, 1);
    };
    
    var fnScrollHandler = function(ev) {
      var windowBottom = (window.innerHeight + window.scrollY);
      var postBottom = ($postFooter.offset().top + $postFooter.outerHeight()) + 150;

      if (windowBottom > postBottom) {
        fnShowPopup();
        window.removeEventListener('scroll', fnScrollHandler, false);
      }
    }; 

    /* DISABLED May 2019.  Popup now shows when page is loaded 
    // Show popup after user has scrolled a certain distance
    window.setTimeout(function() { window.addEventListener('scroll', fnScrollHandler, false); }, 1000);
    */

    // Show popup after a few seconds
    window.setTimeout(fnShowPopup, 2000);
  }
  
  function init() {
    $('form.newsletterForm').on('submit', handleNewsletterSubmit);
    initPopupCta();
  }
  
  $(init);
})(jQuery);
